<template>
    <v-container fluid>
        <v-layout>
            <v-flex><h1 class="display-2">Gestión de usuarios</h1></v-flex>
        </v-layout>
        <v-layout column>
            <v-data-table :headers="headers" :items="items" class="elevation-1"
                          :pagination.sync="pag"
                          :loading="loading"
                          :rows-per-page-items="rows"
                          rows-per-page-text="Filas por pagina"
                          :total-items="totalItems"
            >
                <template slot="items" slot-scope="props">
                    <td class="text-xs-right">{{ props.item.name }}</td>
                    <td class="text-xs-right">{{ props.item.email }}</td>
                    <td class="text-xs-right">{{ props.item.department }}</td>
                    <td class="text-xs-right">
                        <template v-for="role in props.item.roles">
                            <v-chip small>{{ role.display_name }}</v-chip>
                        </template>
                    </td>
                    <td class="text-xs-center">
                        <v-tooltip top>
                            <v-btn slot="activator" flat icon color="blue" @click.native="rolAsignarDialog(props.item)">
                                <v-icon>vpn_key</v-icon>
                            </v-btn>
                            <span>Asignación de roles</span>
                        </v-tooltip>
                    </td>
                </template>
            </v-data-table>
            <v-dialog v-model="rolDialog" scrollable max-width="900">
                <v-card tile>
                    <v-toolbar card dense dark color="primary">
                        <v-toolbar-items>
                            <v-select solo v-model="rol" :items="roles" item-value="id" item-text="display_name" label="Seleccione rol"></v-select>
                            <v-btn flat @click.native="rolAsignar" :loading="loadingAsignar">
                                Agregar
                            </v-btn>
                        </v-toolbar-items>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click.native="rolDialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-list two-line>
                            <template v-for="r in rolesAsignados">
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ r.display_name }}</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ r.description }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn color="red" flat icon @click.native="rolQuitar(r)" :loading="r.id === loadingQuitar">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider></v-divider>
                            </template>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-layout>
        <errores v-model="msj.mostrar" :datos="msj"></errores>
    </v-container>
</template>

<script>
    import errores from '../../components/Errores';
    import mixinUser from '../../mixins/auth/users';
    import mixinRole from '../../mixins/auth/roles';

    export default {
        name: "usuarios",
        components: {errores},
        mixins: [mixinUser, mixinRole],
        data() {
            return {
                loading: false,
                loadingAsignar: false,
                loadingQuitar: -1,
                headers: [
                    {text: 'Nombre de usuario', value: 'name', align: 'center'},
                    {text: 'Email', value: 'email', align: 'center'},
                    {text: 'Departamento', value: 'department', align: 'center'},
                    {text: 'Roles Asignados', value: '', align: 'center'},
                    {text: 'Operaciones', value: '', align: 'center'},

                ],
                items: [],
                pag: {},
                rows: [10, 20, 30, {text: 'All', value: -1}],
                totalItems: 0,
                msj: {mostrar: false, txt: '', tipo: ''},
                rolDialog: false,
                roles: [],
                rol: '',
                rolesAsignados: [],
                usuActivo: {}
            }
        },
        watch: {
            pag: {
                handler() {
                    this.getTable();
                },
                deep: true
            },
            rolDialog(newVal, oldVal) {
                if (!newVal) {
                    this.getTable();
                }
            }

        },
        mounted() {
            this.getTable();
            this.rolesList(r => {
                this.roles = r;
            })
        },
        methods: {
            getTable() {
                this.loading = true;
                this.usersTable(this.pag, r => {
                    this.items = r.data;
                    this.totalItems = r.total;
                    this.loading = false;
                }, err => {
                    this.loading = false;
                    console.log(err);
                })
            },
            rolAsignar() {
                this.loadingAsignar = true;
                this.userAsginarRoles({
                    user_id: this.usuActivo.id,
                    role_id: this.rol
                }, r => {
                    this.msj = r;
                    this.getRoles();
                    this.loadingAsignar = false;
                }, err => {
                    this.loadingAsignar = false;
                    console.log(err);
                })
            },
            rolAsignarDialog(item) {
                this.usuActivo = item;
                this.getRoles();
            },
            getRoles() {
                this.userRoles({
                    user_id: this.usuActivo.id
                }, r => {
                    this.rolesAsignados = r;
                    this.rolDialog = true;
                }, err => {
                    console.log(err)
                })
            },
            rolQuitar(item) {
                this.loadingQuitar = item.id;
                this.userQuitarRoles({
                    user_id: this.usuActivo.id,
                    role_id: item.id
                }, r => {
                    this.loadingQuitar = -1;
                    this.msj = r;
                    this.getRoles();
                }, err => {
                    console.log(err)
                    this.loadingQuitar = -1;
                })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/auth/usuarios.vue